
























































































































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import InvoiceSyncSettingForm from '../invoice-sync-setting-form/invoice-sync-setting-form.vue';

@Component({
  name: 'bpc-payment-sync-modal',
  components: {
    'bpc-invoice-sync-setting-form': InvoiceSyncSettingForm,
  },
})
export default class PaymentSyncModal extends Vue {
  // PROPS
  @Prop({ type: String, default: 'payment-sync-confirmation-modal' }) readonly modalId: string;
  @Prop({ type: String }) readonly uxSessionCode: string;
  @Prop({ type: Boolean, default: false }) readonly loading: boolean;
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop({ type: Boolean, default: false }) readonly paymentSyncRequestSent: boolean;
  @Prop({ type: Boolean, default: false }) readonly isSyncingPayments: boolean;
  @Prop({ type: Boolean, default: false }) readonly showInvoiceSyncSettingForm: boolean;
  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  readonly paymentSyncEventsSuccess: any[]; // TODO use the right type
  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  readonly paymentSyncEventsError: any[]; // TODO use the right type

  // DATA

  public errorReportPerPage: number = 5;
  public errorReportCurrentPage: number = 1;
  public successReportPerPage: number = 5;
  public successReportCurrentPage: number = 1;

  // LIFECYCLE HOOKS

  // COMPUTED
  get modalConfig() {
    return {
      id: 'modal-sync-payments',
      title: this.$t('global.modals.sync_payments.title') as string,
      body: this.$t('global.modals.sync_payments.body') as string,
      cancelText: this.$t('global.buttons.cancel') as string,
      acceptText: this.$t('global.buttons.confirm') as string,
      acceptButtonVariant: 'info',
    };
  }

  get errorReportRows() {
    return this.paymentSyncEventsError.length;
  }
  get errorReportCurrentList() {
    const start = (this.errorReportCurrentPage - 1) * this.errorReportPerPage;
    const end = start + this.errorReportPerPage;
    return this.paymentSyncEventsError.slice(start, end);
  }

  get successReportRows() {
    return this.paymentSyncEventsSuccess.length;
  }
  get successReportCurrentList() {
    const start = (this.successReportCurrentPage - 1) * this.successReportPerPage;
    const end = start + this.successReportPerPage;
    return this.paymentSyncEventsSuccess.slice(start, end);
  }

  // METHODS
  onCloseModal() {
    this.$emit('close-modal');
  }
  onConfirmSyncAllPayments() {
    this.$emit('confirm-sync-all-payments');
  }
  onConfirmSyncPayments() {
    this.$emit('confirm-sync-payments');
  }

  // WATCHERS
  @Watch('showModal')
  onShowModalChange() {
    if (this.showModal) {
      this.errorReportCurrentPage = 1;
      this.successReportCurrentPage = 1;
    }
  }
}
